"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoResourceTemplateSchema = void 0;
exports.VideoResourceTemplateSchema = {
    "$id": "https://www.redbull.com/schemas/templates/video-resource.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "VideoResourceTemplate",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/apple-immersive-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/episode-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/films.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/recap-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/trailer-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/video-3d.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/videos-360.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8tcmVzb3VyY2Uuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvdGVtcGxhdGVzL3ZpZGVvLXJlc291cmNlLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLDJCQUEyQixHQUFHO0lBQ3pDLEtBQUssRUFBRSxzRUFBc0U7SUFDN0UsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsdUJBQXVCO0lBQ2hDLE9BQU8sRUFBRTtRQUNQO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLDRFQUE0RTtTQUNyRjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLG9FQUFvRTtTQUM3RTtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLDJEQUEyRDtTQUNwRTtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLGtFQUFrRTtTQUMzRTtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLG9FQUFvRTtTQUM3RTtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLDhEQUE4RDtTQUN2RTtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLDREQUE0RDtTQUNyRTtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLGdFQUFnRTtTQUN6RTtLQUNGO0NBQ0YsQ0FBQSJ9